import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Button } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';
import {
  businessAtom,
  profileAtom
} from '../../../../../atoms/Atoms';
import paypal from '../../../../../assets/images/paypal.png';
import api from '../../../../../api/api';

function Header() {
  const business = useRecoilValue(businessAtom);
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const profile = useRecoilValueLoadable(profileAtom);
  const isAdmin =
    profile.contents && profile?.contents?.roles?.includes('SuperAdmin');
  const { t } = useTranslation();

  const getData = function () {
    setLoading(true);
    api
      .get(`businesses/v2/${business.id}`)
      .then((response) => {
        setLoading(false);
        setData(response.data.data);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const updatePaypalTransfers = function (isOn) {
    setLoading(true);
    api.put(
      `businesses/updatepaymentdailytransfer/${business?.locations[0].id}/${isOn}/5`,
      { }
    )
      .then((response) => {
        setLoading(false);
        const temp = JSON.parse(JSON.stringify(data));
        temp.allowPaypalTransfer = isOn;
        setData(temp);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const updatePaypalPayout = function (isOn) {
    setLoading(true);
    const temp = JSON.parse(JSON.stringify(data));
    temp.allowPaypalTransfer = isOn;
    api.put(
      `businesses/${business?.id}`,
      temp
    )
      .then((response) => {
        setLoading(false);
        const temp2 = JSON.parse(JSON.stringify(data));
        temp2.allowPaypalTransfer = isOn;
        setData(temp2);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (business) {
      getData();
    }
  }, [business]);

  useEffect(() => {
    if (business) {
      getData();
    }
  }, [refresh]);

  return (
    <PageHeader
      className="mb-4 px-0"
      title="PayPal"
      avatar={{ src: paypal }}
      tags={
        <Tag
          color="#2db7f5"
          icon={business ? <CheckCircleOutlined /> : <SyncOutlined spin />}
        >
          {business ? business.name : 'Loading...'}
        </Tag>
      }
      extra={
        data && [
          <Button
            id="reload"
            type="primary"
            key="reload"
            size="small"
            onClick={() => setRefresh(true)}
          >
            {t('reload')}
          </Button>,
          <Button
            key="payouts"
            size="small"
            onClick={() => {
              if (isAdmin) {
                updatePaypalPayout(!data.allowPaypalTransfer);
              }
            }}
            loading={loading}
            style={{
              color: '#fff',
              border: 'none',
              backgroundColor: data?.allowPaypalTransfer ? '#108ee9' : '#f50'
            }}
          >
            {data?.allowPaypalTransfer ? (
              <CheckCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            )}
            Payouts Service{' '}
            {data?.allowPaypalTransfer ? 'Enabled' : 'Disabled'}
          </Button>,
        ]
      }
    />
  );
}

export default Header;
